import { render, staticRenderFns } from "./SmartCoupon.vue?vue&type=template&id=40bd2dbd&scoped=true"
import script from "./SmartCoupon.vue?vue&type=script&lang=js"
export * from "./SmartCoupon.vue?vue&type=script&lang=js"
import style0 from "./SmartCoupon.vue?vue&type=style&index=0&id=40bd2dbd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd2dbd",
  null
  
)

export default component.exports